import { InjectionToken } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { environment } from "../../environments/environment";
import { forgetSessionsFromAnotherAuthority } from "./token-authority";

/**
 * Sends the user to sign in, back to the page they are on afterwards (AuthenticationFactory reads
 * `returnUrl`). With `forgetSession`, the session kept in the browser is dropped first - a token from
 * another login server, which every API refuses.
 *
 * When that session also held the other server's discovery document, the page is loaded again instead: the
 * library has already read it into its configuration and would build the sign-in from it ("Issuer
 * mismatch"). After the reload nothing is left to remove, so this cannot repeat.
 */
export function signInAgain(oidc: OidcSecurityService, forgetSession: boolean, reload: () => void = () => window.location.reload()): void {
  sessionStorage.setItem('returnUrl', window.location.pathname + window.location.search);
  if (forgetSession) {
    if (forgetSessionsFromAnotherAuthority(sessionStorage, environment.authority)) {
      reload();
      return;
    }
    oidc.logoffLocal();
  }
  oidc.authorize();
}

/** Signing in again has started: the page is leaving, so later refusals start nothing more. One per app. */
export const SIGNING_IN_AGAIN = new InjectionToken<{ started: boolean }>('SIGNING_IN_AGAIN', {
  providedIn: 'root',
  factory: () => ({ started: false }),
});
